import { ChakraFlex, SkeletonLoader } from '@equip.health/ui';

const PendingNotesSkeleton = () => (
  <ChakraFlex data-testid="pending-notes-skeleton" direction="column">
    {[...Array(5)].map((_, i) => (
      <ChakraFlex
        key={i}
        padding="16px 0"
        borderTop={i > 0 ? '1px solid' : 'none'}
        borderColor="neutral.line"
        gap="12px"
        alignItems="center"
      >
        <ChakraFlex direction="column" gap="4px" flex="1">
          <SkeletonLoader
            height="16px"
            width={`${60 + i * 10}%`}
            id={`pending-notes-skeleton-name-${i}`}
            startColor="neutral.line"
            endColor="neutral.background.secondary"
          />
          <SkeletonLoader
            height="14px"
            width={`${40 + i * 15}%`}
            id={`pending-notes-skeleton-meta-details-${i}`}
            startColor="neutral.line"
            endColor="neutral.background.secondary"
          />
          <SkeletonLoader
            height="14px"
            width={`${40 + i * 15}%`}
            id={`pending-notes-skeleton-title-${i}`}
            startColor="neutral.line"
            endColor="neutral.background.secondary"
          />
        </ChakraFlex>
        <SkeletonLoader
          height="22px"
          width="50px"
          id={`pending-notes-skeleton-badge-${i}`}
          startColor="neutral.line"
          endColor="neutral.background.secondary"
        />
      </ChakraFlex>
    ))}
  </ChakraFlex>
);

export default PendingNotesSkeleton;
